"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = hover;
exports.unhover = unhover;

var _dom = require("@testing-library/dom");

var _utils = require("./utils"); // includes `element`


function getParentElements(element) {
  var parentElements = [element];
  var currentElement = element;

  while ((currentElement = currentElement.parentElement) != null) {
    parentElements.push(currentElement);
  }

  return parentElements;
}

function hover(element, init) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$skipPointerEvent = _ref.skipPointerEventsCheck,
      skipPointerEventsCheck = _ref$skipPointerEvent === void 0 ? false : _ref$skipPointerEvent;

  if (!skipPointerEventsCheck && !(0, _utils.hasPointerEvents)(element)) {
    throw new Error('unable to hover element as it has or inherits pointer-events set to "none".');
  }

  if ((0, _utils.isLabelWithInternallyDisabledControl)(element)) return;
  var parentElements = getParentElements(element).reverse();

  _dom.fireEvent.pointerOver(element, init);

  var _iterator = _createForOfIteratorHelper(parentElements),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _el = _step.value;

      _dom.fireEvent.pointerEnter(_el, init);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (!(0, _utils.isDisabled)(element)) {
    _dom.fireEvent.mouseOver(element, (0, _utils.getMouseEventOptions)('mouseover', init));

    var _iterator2 = _createForOfIteratorHelper(parentElements),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var el = _step2.value;

        _dom.fireEvent.mouseEnter(el, (0, _utils.getMouseEventOptions)('mouseenter', init));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  _dom.fireEvent.pointerMove(element, init);

  if (!(0, _utils.isDisabled)(element)) {
    _dom.fireEvent.mouseMove(element, (0, _utils.getMouseEventOptions)('mousemove', init));
  }
}

function unhover(element, init) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$skipPointerEven = _ref2.skipPointerEventsCheck,
      skipPointerEventsCheck = _ref2$skipPointerEven === void 0 ? false : _ref2$skipPointerEven;

  if (!skipPointerEventsCheck && !(0, _utils.hasPointerEvents)(element)) {
    throw new Error('unable to unhover element as it has or inherits pointer-events set to "none".');
  }

  if ((0, _utils.isLabelWithInternallyDisabledControl)(element)) return;
  var parentElements = getParentElements(element);

  _dom.fireEvent.pointerMove(element, init);

  if (!(0, _utils.isDisabled)(element)) {
    _dom.fireEvent.mouseMove(element, (0, _utils.getMouseEventOptions)('mousemove', init));
  }

  _dom.fireEvent.pointerOut(element, init);

  var _iterator3 = _createForOfIteratorHelper(parentElements),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _el2 = _step3.value;

      _dom.fireEvent.pointerLeave(_el2, init);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  if (!(0, _utils.isDisabled)(element)) {
    _dom.fireEvent.mouseOut(element, (0, _utils.getMouseEventOptions)('mouseout', init));

    var _iterator4 = _createForOfIteratorHelper(parentElements),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var el = _step4.value;

        _dom.fireEvent.mouseLeave(el, (0, _utils.getMouseEventOptions)('mouseleave', init));
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
}